/**
 * Tools for debug pane
 */

import { log } from '../log';

type Item = number | string | boolean;

class DebugTools {
  logs: Item[][] = [];

  _log: typeof log.log;
  _origLog: typeof log.log | undefined;

  constructor() {
    this._log = (...params) => {
      const items: Item[] = params.filter((item) => {
        const isBoolean = typeof item === 'boolean';
        const isNumber = typeof item === 'number';
        const isString = typeof item === 'string';

        return isBoolean || isNumber || isString;
      });

      this.logs.push(items);
      this._origLog?.(...params);
    };
  }

  wrapLogs() {
    if (typeof log.log === 'function') {
      this._origLog = log.log.bind(log);
      log.log = this._log;
    }
  }
}

const debugTools = new DebugTools();
// debugTools.wrapLogs();

export { debugTools };
